export const isAnnuityPolicy = (policy) => {
  return policy?.product?.type?.toUpperCase().startsWith("A");
};
